'use strict';

define(['utils/helpers', 'providers/providers', 'controller/storage', 'controller/qoe', 'utils/underscore', 'utils/backbone.events', 'utils/simplemodel', 'events/events', 'events/states', 'baidu/adv-manage'], function (utils, Providers, Storage, QOE, _, Events, SimpleModel, events, states, AdvManage) {

    // Represents the state of the player
    var Model = function Model() {
        var _this = this,

        // Video provider
        _providers,
            _provider,
            _item,
            _storage,
            _currentProvider = utils.noop;

        this.mediaController = _.extend({}, Events);
        this.mediaModel = new MediaModel();
        this.advManage = null;

        QOE.model(this);

        this.set('mediaModel', this.mediaModel);

        this.setup = function (config) {
            _storage = new Storage();

            _.extend(this.attributes, config, {
                // always start on first playlist item
                item: 0,
                // Initial state, upon setup
                state: states.IDLE,
                // Initially we don't assume Flash is needed
                flashBlocked: false,
                fullscreen: false,
                compactUI: false,
                scrubbing: false,
                duration: 0,
                position: 0,
                buffer: 0
            });

            // Mobile doesn't support autostart
            // This check should be replaced with something that detects whether the current system
            // requires a user interaction to start playback
            if (utils.isMobile() && !config.mobileSdk) {
                this.set('autostart', false);
            }

            // 加载广告 zhangzhe 2017-05-03
            if (this.get('imageAdvs')) {
                this.advManage = new AdvManage(this.get('imageAdvs'));
            }

            this.updateProviders();

            return this;
        };

        this.getConfiguration = function () {
            return _.omit(this.clone(), ['mediaModel']);
        };

        this.updateProviders = function () {
            _providers = new Providers(this.getConfiguration());
        };

        function _videoEventHandler(type, data) {
            var evt = _.extend({}, data, { type: type });
            switch (type) {
                case 'flashThrottle':
                    var throttled = data.state !== 'resume';
                    this.set('flashThrottle', throttled);
                    this.set('flashBlocked', throttled);
                    break;

                case 'flashBlocked':
                    this.set('flashBlocked', true);
                    return;
                case 'flashUnblocked':
                    this.set('flashBlocked', false);
                    return;

                case 'volume':
                case 'mute':
                    this.set(type, data[type]);
                    return;

                case events.JWPLAYER_MEDIA_TYPE:
                    if (this.mediaModel.get('mediaType') !== data.mediaType) {
                        this.mediaModel.set('mediaType', data.mediaType);
                        this.mediaController.trigger(type, evt);
                    }
                    return;

                case events.JWPLAYER_PLAYER_STATE:
                    this.mediaModel.set('state', data.newstate);

                    // This "return" is important because
                    //  we are choosing to not propagate this event.
                    //  Instead letting the master controller do so
                    return;

                case events.JWPLAYER_MEDIA_BUFFER:
                    this.set('buffer', data.bufferPercent);

                /* falls through */
                case events.JWPLAYER_MEDIA_META:
                    var duration = data.duration;
                    if (_.isNumber(duration)) {
                        this.mediaModel.set('duration', duration);
                        this.set('duration', duration);
                    }
                    // 如果时长为 Infinity，则显示直播状态
                    if (data.duration === Infinity) {
                        this.trigger('alive');
                    }
                    break;

                case events.JWPLAYER_MEDIA_BUFFER_FULL:
                    // media controller
                    if (this.mediaModel.get('playAttempt')) {
                        this.playVideo();
                    } else {
                        this.mediaModel.on('change:playAttempt', function () {
                            this.playVideo();
                        }, this);
                    }
                    break;

                case events.JWPLAYER_MEDIA_TIME:
                    this.mediaModel.set('position', data.position);
                    this.set('position', data.position);
                    if (_.isNumber(data.duration)) {
                        this.mediaModel.set('duration', data.duration);
                        this.set('duration', data.duration);
                        // 时时记录视频播放的时间点
                        if (data.duration > 0) {
                            this.recordMediaPosition(data.position, data.duration);
                        }
                        // 如果时长为 Infinity，则显示直播状态
                        if (data.duration === Infinity) {
                            this.trigger('alive');
                        }
                    }
                    // 判断是否要显示过程广告
                    if (this.advManage && this.get('imageAdvs').advs) {
                        this.advManage.refreshProcessAdv(data.position);
                    }
                    break;
                case events.JWPLAYER_PROVIDER_CHANGED:
                    this.set('provider', _provider.getName());
                    break;

                case events.JWPLAYER_MEDIA_LEVELS:
                    this.setQualityLevel(data.currentQuality, data.levels);
                    this.mediaModel.set('levels', data.levels);
                    break;
                case events.JWPLAYER_MEDIA_LEVEL_CHANGED:
                    this.setQualityLevel(data.currentQuality, data.levels);
                    this.persistQualityLevel(data.currentQuality, data.levels);
                    break;
                case events.JWPLAYER_AUDIO_TRACKS:
                    this.setCurrentAudioTrack(data.currentTrack, data.tracks);
                    this.mediaModel.set('audioTracks', data.tracks);
                    break;
                case events.JWPLAYER_AUDIO_TRACK_CHANGED:
                    this.setCurrentAudioTrack(data.currentTrack, data.tracks);
                    break;
                case events.JWPLAYER_CONNECTING:
                    this.trigger('connecting');
                    break;
                case events.JWPLAYER_CONNECT_FAILD:
                    this.trigger('connectFaild');
                    break;
                case events.JWPLAYER_ALIVE:
                    this.trigger('alive');
                    break;
                case events.JWPLAYER_NO_LIVE_STREAM:
                    this.trigger('noLiveStream');
                    break;
                case events.JWPLAYER_LIVE_STOP:
                    this.trigger('liveStop');
                    break;
                case 'stop':
                    this.set('duration', 0);
                    break;
                case 'subtitlesTrackChanged':
                    this.setVideoSubtitleTrack(data.currentTrack, data.tracks);
                    break;
                case 'visualQuality':
                    var visualQuality = _.extend({}, data);
                    this.mediaModel.set('visualQuality', visualQuality);
                    break;
                case events.JWPLAYER_PLAYBACKRATE:
                    this.set('playbackRate', data.playbackRate);
                    this.mediaModel.set('playbackRate', data.playbackRate);
            }

            this.mediaController.trigger(type, evt);
        }

        // 记录视频播放时间点，直播不记录时间 2016-04-13
        this.recordMediaPosition = function (position, duration) {
            var source = _item && _item.sources && _item.sources[0];
            if (source && source.file && !isNaN(position) && !isNaN(duration) && duration > 0 && isFinite(duration) !== false) {
                // 多码率的每个时间点都记录时间
                _.each(_item.sources, function (source) {
                    // 大于两秒才开始记录，且手机上不支持此功能
                    if (position < duration && position > 2) {
                        _storage.setItem('filePostion.' + source.file, position);
                    } else if (position >= duration) {
                        // 放完之后清空播放时间点记录
                        // ps: IE下position可能大于duration zhangzhe 2017-01-18
                        _storage.clearItem('filePostion.' + source.file);
                    }
                });
            }
        };

        // 获取某个视频上次播放的时间点
        this.getLastPosition = function (item) {
            var lastPosition = 0;
            if (item && utils.typeOf(item.sources) === 'array' && item.sources.length > 0 && _storage.getItem('filePostion.' + item.sources[0].file)) {
                lastPosition = _storage.getItem('filePostion.' + item.sources[0].file);
            }
            return lastPosition;
        };

        this.setQualityLevel = function (quality, levels) {
            if (quality > -1 && levels.length > 1) {
                this.mediaModel.set('currentLevel', parseInt(quality));
            }
        };

        this.setCurrentQuality = function (quality) {
            _provider.setCurrentQuality(quality);
        };

        this.persistQualityLevel = function (quality, levels) {
            var currentLevel = levels[quality] || {};
            var label = currentLevel.label;
            this.set('qualityLabel', label);
        };

        this.setCurrentAudioTrack = function (currentTrack, tracks) {
            if (currentTrack > -1 && tracks.length > 0 && currentTrack < tracks.length) {
                this.mediaModel.set('currentAudioTrack', parseInt(currentTrack));
            }
        };

        this.onMediaContainer = function () {
            var container = this.get('mediaContainer');
            _currentProvider.setContainer(container);
        };

        this.changeVideoProvider = function (Provider) {
            var providerChangeHandler = function providerChangeHandler() {
                this.setVolume(this.get('volume'));
            };
            this.off('change:mediaContainer', this.onMediaContainer);

            if (_provider) {
                _provider.off(null, null, this);
                if (_provider.getContainer()) {
                    _provider.remove();
                }
            }

            if (!Provider) {
                _provider = _currentProvider = Provider;
                this.set('provider', undefined);
                return;
            }

            _currentProvider = new Provider(_this.get('id'), _this.getConfiguration());

            var container = this.get('mediaContainer');
            if (container) {
                _currentProvider.setContainer(container);
            } else {
                this.once('change:mediaContainer', this.onMediaContainer);
            }

            // html5 provider 最大支持音量 100%，flash provider 最大支持音量500%，所以切换 provider 的时候重新设置下音量
            this.once('change:provider', providerChangeHandler, this);
            this.set('provider', _currentProvider.getName());

            if (_currentProvider.getName().name.indexOf('flash') === -1) {
                this.set('flashThrottle', undefined);
                this.set('flashBlocked', false);
            }

            _provider = _currentProvider;
            _provider.volume(_this.get('volume'));
            _provider.mute(_this.get('mute'));
            _provider.on('all', _videoEventHandler, this);
        };

        this.destroy = function () {
            if (_provider) {
                _provider.off(null, null, this);
                _provider.destroy();
            }
        };

        this.getVideo = function () {
            return _provider;
        };

        this.setFullscreen = function (state) {
            state = !!state;
            if (state !== _this.get('fullscreen')) {
                _this.set('fullscreen', state);
            }
        };

        // Give the option for a provider to be forced
        this.chooseProvider = function (source) {
            return _providers.choose(source).provider;
        };

        this.setActiveItem = function (item) {
            // Item is actually changing
            this.mediaModel.off();
            this.mediaModel = new MediaModel();
            this.set('mediaModel', this.mediaModel);
            this.set('position', item.starttime || 0);
            this.set('duration', item.duration || 0);

            this.setProvider(item);
        };

        this.setProvider = function (item) {
            var source = item && item.sources && item.sources[0];
            if (source === undefined) {
                // source is undefined when resetting index with empty playlist
                return;
            }

            _item = item;

            var provider = this.chooseProvider(source);
            // If we are changing video providers
            if (!provider || !(_currentProvider instanceof provider)) {
                _this.changeVideoProvider(provider);
            }

            if (!_currentProvider) {
                return;
            }

            // this allows the providers to preload
            if (_currentProvider.init) {
                _currentProvider.init(item, this.attributes);
            }

            // Listening for change:item won't suffice when loading the same index or file
            // We also can't listen for change:mediaModel because it triggers whether or not
            //  an item was actually loaded
            this.trigger('itemReady', item);
        };

        this.getCurrentItem = function () {
            return _item;
        };

        this.getProviders = function () {
            return _providers;
        };

        this.resetProvider = function () {
            _currentProvider = null;
        };

        this.setVolume = function (vol) {
            vol = Math.round(vol);

            // html5 provider 不能设置大于 100
            if (_provider && _provider.getName().name === 'html5') {
                vol = Math.min(vol, 100);
            } else {
                // flash provider 不能设置大于 500
                vol = Math.min(vol, 500);
            }

            _this.set('volume', vol);
            if (_provider) {
                _provider.volume(vol);
            }
            var muted = vol === 0;
            if (muted !== _this.get('mute')) {
                _this.setMute(muted);
            }
        };

        this.enableGPU = function () {
            _provider.enableGPU();
        };

        this.disableGPU = function () {
            _provider.disableGPU();
        };

        this.setToken = function (tokens) {
            var _tokens = [];

            if (typeof arguments[0] === 'string' && typeof arguments[1] === 'string') {
                _tokens[0] = {
                    file: arguments[0],
                    tokenText: arguments[1]
                };

                tokens = _tokens;
            }

            if (_provider.setToken) {
                _provider.setToken(tokens);
            }
        };

        this.setMute = function (mute) {
            if (!utils.exists(mute)) {
                mute = !this.get('mute');
            }
            this.set('mute', mute);
            if (_provider) {
                _provider.mute(mute);
            }
            if (!mute) {
                var volume = Math.max(10, this.get('volume'));
                this.setVolume(volume);
            }
        };

        // The model is also the mediaController for now
        this.loadVideo = function (item) {
            if (!item) {
                var idx = this.get('item');
                item = this.get('playlist')[idx];
            }

            // 获取开始播放的时间
            // 如果用户没有配置，就从本地缓存中取上次播放结束的时间
            item.starttime = this.getLastPosition(item);
            // 如果设置了starttime，无条件覆盖，这样当starttime=0时，禁用startseek功能
            if (this.get('starttime') !== undefined) {
                item.starttime = this.get('starttime');
            }

            this.set('position', item.starttime || 0);
            this.set('duration', item.duration || 0);
            this.mediaModel.set('playAttempt', true);
            this.mediaController.trigger(events.JWPLAYER_MEDIA_PLAY_ATTEMPT, { 'playReason': this.get('playReason') });

            _provider.load(item);
        };

        this.stopVideo = function () {
            if (_provider) {
                _provider.stop();
            }
        };

        this.playVideo = function () {
            _provider.play();
        };

        this.persistCaptionsTrack = function () {
            var track = this.get('captionsTrack');

            if (track) {
                // update preference if an option was selected
                this.set('captionLabel', track.label);
            } else {
                this.set('captionLabel', 'Off');
            }
        };

        this.setVideoSubtitleTrack = function (trackIndex, tracks) {
            this.set('captionsIndex', trackIndex);
            /*
             * Tracks could have changed even if the index hasn't.
             * Need to ensure track has data for captionsrenderer.
             */
            if (trackIndex && tracks && trackIndex <= tracks.length && tracks[trackIndex - 1].data) {
                this.set('captionsTrack', tracks[trackIndex - 1]);
            }

            if (_provider && _provider.setSubtitlesTrack) {
                _provider.setSubtitlesTrack(trackIndex);
            }
        };

        this.persistVideoSubtitleTrack = function (trackIndex) {
            this.setVideoSubtitleTrack(trackIndex);
            this.persistCaptionsTrack();
        };

        this.setPlaybackRate = function (playbackRate) {
            _provider.setPlaybackRate(playbackRate);
        };
    };

    // Represents the state of the provider/media element
    var MediaModel = Model.MediaModel = function () {
        this.set('state', states.IDLE);
    };

    _.extend(Model.prototype, SimpleModel);
    _.extend(MediaModel.prototype, SimpleModel);

    return Model;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/controller/model.js
 ** module id = 144
 ** module chunks = 0
 **/